var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFusions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4976_8488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3751 24.125H20.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 24.125H65.625",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 56.1249H36.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 56.1249H65.625",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.375 40.1249H20.5",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 40.125L65.625 40.1249",
    stroke: "#161616",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 21C20.5 20.4477 20.9477 20 21.5 20H42.0529C42.371 20 42.6701 20.1513 42.8585 20.4076L45.0644 23.4076C45.3236 23.76 45.3236 24.24 45.0644 24.5924L42.8585 27.5924C42.6701 27.8487 42.371 28 42.0529 28H21.5C20.9477 28 20.5 27.5523 20.5 27V21Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 53C36.5 52.4477 36.9477 52 37.5 52H58.0529C58.371 52 58.6701 52.1513 58.8585 52.4076L61.0644 55.4076C61.3236 55.76 61.3236 56.24 61.0644 56.5924L58.8585 59.5924C58.6701 59.8487 58.371 60 58.0529 60H37.5C36.9477 60 36.5 59.5523 36.5 59V53Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 37C20.5 36.4477 20.9477 36 21.5 36H58.0529C58.371 36 58.6701 36.1513 58.8585 36.4076L61.0644 39.4076C61.3236 39.76 61.3236 40.24 61.0644 40.5924L58.8585 43.5924C58.6701 43.8487 58.371 44 58.0529 44H21.5C20.9477 44 20.5 43.5523 20.5 43V37Z",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5 36L42.0056 39.4076C42.2647 39.76 42.2647 40.24 42.0056 40.5924L39.5 44",
    stroke: "#161616",
    strokeWidth: 1.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0981 33L29.5 30H34.6962L32.0981 33Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 47L51.0981 50H45.9019L48.5 47Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4976_8488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusions);
export default __webpack_public_path__ + "static/media/fusions.8d07787d26a7394db08d7ef6c7b7f8c8.svg";
export { ForwardRef as ReactComponent };